import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import FormContext from './FormContext';

/* eslint-disable react/require-default-props */
export const FormWrapperPropTypes = {
  addToForm: PropTypes.func,
  isValid: PropTypes.func,
  onFormChange: PropTypes.func,
  removeFromForm: PropTypes.func,
  resetta: PropTypes.func,
  stato: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  validare: PropTypes.bool,
};
/* eslint-enable react/require-default-props */

const withForm = (WrappedComponent) => {
  const FormWrapper = forwardRef((props, ref) => (
    <FormContext.Consumer>
      {({
        addToForm,
        isValid,
        onFormChange,
        removeFromForm,
        resetta,
        stato,
        validare,
      }) => (
        <WrappedComponent
          addToForm={addToForm}
          isValid={isValid}
          onFormChange={onFormChange}
          removeFromForm={removeFromForm}
          resetta={resetta}
          stato={stato}
          validare={validare}
          ref={ref}
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...props}
        />
      )}
    </FormContext.Consumer>
  ));
  const getDisplayName = (WComponent) => WComponent.displayName || WComponent.name || 'Component';
  FormWrapper.displayName = `withForm(${getDisplayName(FormWrapper)})`;
  FormWrapper.propTypes = FormWrapperPropTypes;
  return FormWrapper;
};

export default withForm;
